<template>
	<div> 
        <el-upload
          class="upload"
          name="excel"
          action="/apis/excel.php"
          :data="uploadData"
          :before-upload='upBefore'
          :on-success='upScuccess'
          :on-error='upError'
          ref="upload"
          style="float: left;margin-right: 20px">
          <el-button size="medium" type="success" id="imgInput" round element-loading-text="插入中,请稍候">上传EXCEL</el-button>
        </el-upload>
		<el-button id= "add" type="primary" size="medium" round @click = "dialogFormVisible = true">添加车辆</el-button>
		<el-dialog title="添加车辆" :visible.sync="dialogFormVisible">
			<el-form :model="form" :rules="rules" ref="ruleForm" size="small" status-icon>
				<el-form-item label="车牌号" :label-width="formLabelWidth" prop="cph">
					<el-input v-model="form.cph" auto-complete="off"></el-input>
				</el-form-item>

			<el-form-item label="所属单位" :label-width="formLabelWidth" prop="ssdw">
				<el-select v-model="form.ssdw" placeholder="请选择所属单位">
					<el-option
						v-for="item in danwei"
						:key="item.id"
						:label="item.name"
						:value="'danwei'+item.id">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="车牌颜色" :label-width="formLabelWidth" prop="cpys">
			    <el-radio-group v-model="form.cpys" size="medium">
			      <el-radio-button label="黄" ></el-radio-button>
			      <el-radio-button label="蓝"></el-radio-button>
			      <el-radio-button label="其他"></el-radio-button>
			    </el-radio-group>
			</el-form-item>

<!-- 			<el-form-item label="类型" :label-width="formLabelWidth" prop="lx">
			    <el-radio-group v-model="form.lx" size="medium">
			      <el-radio-button label="危险品运输" ></el-radio-button>
			      <el-radio-button label="普通货物运输"></el-radio-button>
			      <el-radio-button label="旅客运输"></el-radio-button>
			    </el-radio-group>
			</el-form-item> -->

			<el-form-item label="运输类型" :label-width="formLabelWidth" prop="lx">
			  <el-select v-model="form.lx" placeholder="请选择">
			      <el-option
			        v-for="item in this.options"
			        :key="item.value"
			        :label="item.text"
			        :value="item.value">
			      </el-option>
			  </el-select>
			</el-form-item>

			<el-form-item label="状态" :label-width="formLabelWidth" prop="zt">
			    <el-radio-group v-model="form.zt" size="medium">
			      <el-radio-button label="正常" ></el-radio-button>
			      <el-radio-button label="维修"></el-radio-button>
			      <el-radio-button label="停运"></el-radio-button>
			    </el-radio-group>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="resetForm('ruleForm');">取 消</el-button>
			<el-button type="primary" @click="submitForm('ruleForm');">确 定</el-button>
		</div>
	</el-dialog>
</div>
</template>

<script>
	export default {
		name: 'addc',
		computed:{
			danwei(){
				return this.$store.state.danwei;
			}
		},
		data() {
			return {
				uploadData:{
					token:'cqgU1wqtfzcZRAniU',
					admin:this.$store.getters.name,
					my:this.$store.getters.token
				},
				value: '',
				dialogFormVisible: false,
				form: {
					cph: '豫',
					ssdw: '',
					cpys:'黄',
					hdzzl:'',
					lx:'1类 爆炸品',
					zt:'正常'
				},
				options:[
					{ text: '1类 爆炸品', value: '1类 爆炸品' }, 
					{ text: '2类1项 易燃气体', value: '2类1项 易燃气体'}, 
					{ text: '2类2项 不燃气体', value: '2类2项 不燃气体' },
					{ text: '2类3项 有毒气体', value: '2类3项 有毒气体'}, 
					{ text: '3类 易燃液体', value: '3类 易燃液体'}, 
					{ text: '4类1项 易燃固体', value: '4类1项 易燃固体'}, 
					{ text: '4类2项 自燃物品', value: '4类2项 自燃物品'}, 
					{ text: '4类3项 遇湿易燃物品', value: '4类3项 遇湿易燃物品'}, 
					{ text: '5类1项 氧化剂', value: '5类1项 氧化剂'},
					{ text: '5类2项 有机过氧化物', value: '5类2项 有机过氧化物'},
					{ text: '6类1项 毒害品', value: '6类1项 毒害品'},
					{ text: '6类2项 感染性物品', value: '6类2项 感染性物品'},
					{ text: '7类 放射性物品', value: '7类 放射性物品'},
					{ text: '8类 腐蚀品', value: '8类 腐蚀品'},
					{ text: '9类 杂类', value: '9类 杂类'},
					{ text: '危险废物', value: '危险废物'},
					{ text: '普通货物运输', value: '普通货物运输' }, 
					{ text: '旅客运输', value: '旅客运输'}
			    ],
				formLabelWidth: '120px',
				rules:{
					cph: [
						{ required: true, message: '请填写车牌号', trigger: 'blur' },
						{ min: 7, max: 7, message: '请检查车牌格式', trigger: 'blur' }
					],
					ssdw: [
						{ required: true, message: '请选择所属单位', trigger: 'blur' }
					],
				}
			};
		},
		methods: {
			upBefore(file){
				if(['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/vnd.ms-excel'].indexOf(file.type)==-1) {
					this.$message.error("只能上传xls/xlsx格式");
					return false;
				}
				if(file.size > 8*1024*1024) {
					this.$message.error("文件大小不要超过8M");
					return false;
				}
			},
		      upError(err, file, fileList){
		        console.log(err);
		        this.$message.error('上传失败');
		      },
		      // 图片上传成功回调   插入到编辑器中
		      upScuccess(ret, file, fileList) {
		        console.log(ret);
		        if (ret.indexOf('token') > -1) {this.$message.error("文件大小不要超过8M");return;}
		        if (ret.indexOf('只能上传xls/xlsx格式') > -1) {this.$message.error(ret);return;}
		        if (ret.indexOf('导入成功') > -1) {
		        	this.$message.success(ret);
		        	this.$emit("rf_cheliang");
		        } else this.$message.error('导入失败');
		      },
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$message({showClose: true,message: '提交中……'});
						this.dialogFormVisible = false;
						this.addCheliang();
					} else {
						this.$message({showClose: true,message: '请检查内容',type: 'warning'});
						return false;
					}
				});
			},
			resetForm(formName) {
				this.dialogFormVisible = false;
				this.$refs[formName].resetFields();
				console.log(this.$store.state.danwei);
			},
			addCheliang(){
				var params = new URLSearchParams();
				params.append('token', 'zqgU1wqtfzcZRAniU');
		        params.append('admin', this.$store.getters.name);
		        params.append('my', this.$store.getters.token);
				params.append('cph', this.form.cph);
				params.append('ssdw', this.form.ssdw);
				params.append('cpys', this.form.cpys);
				params.append('hdzzl', this.form.hdzzl);
				params.append('lx', this.form.lx);
				params.append('zt', this.form.zt);
				this.resetForm('ruleForm');
				this.$ajax.post("/apis/cheliang.php",params).then((ret) => {
			    	// console.log(ret)
			    	if (ret.data == true) {
			    		this.$emit("rf_cheliang");
			    		this.$message({showClose: true,message: '已添加',type: 'success'});
			    	}else this.$notify.error({title: '错误',message: ret.data});
			    }).catch(err=>{
			    	this.$notify.error({title: '错误',message: '网络异常'});
			    });
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Addc.vue